export default __webpack_public_path__ + "static/media/Roboto-Thin.2745c061.ttf";